<template>
  <div
    class="inline-flex items-center justify-center shrink-0 rounded-full bg-app-primary/10 text-app-primary font-semibold"
    :class="size === 'sm' ? 'w-8 h-8 text-xs' : 'w-10 h-10 text-sm'"
  >
    {{ initials }}
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "md",
  },
});

const initials = computed(() => {
  if (!props.name) {
    return "";
  }

  const parts = props.name.trim().split(" ");

  if (parts.length > 1) {
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  return parts[0].substring(0, 2).toUpperCase();
});
</script>
